module.exports = __webpack_public_path__ + "img/challenge.9661b73f.png";